import {
  GET_PAYMENT_PROFILES,
  RESET_PAYMENT_PROFILES_DATA,
  GET_PAYMENT_PROFILE_BY_ID,
  DROP_PAYMENT_PROFILES_DATA,
  CREATE_PAYMENT_PROFILE,
} from 'modules/Finance/PaymentProfiles/store/types'

export const actionGetPaymentProfiles = (props) => ({
  type: GET_PAYMENT_PROFILES,
  payload: props,
})

export const actionCreatePaymentProfile = (props) => ({
  type: CREATE_PAYMENT_PROFILE,
  payload: props,
})

export const actionGetPaymentProfileById = (props) => ({
  type: GET_PAYMENT_PROFILE_BY_ID,
  payload: props,
})

export const actionResetPaymentProfiles = () => ({
  type: RESET_PAYMENT_PROFILES_DATA,
})

export const actionDropPaymentProfiles = () => ({
  type: DROP_PAYMENT_PROFILES_DATA,
})
